"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.sub");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _iconForm = _interopRequireDefault(require("./iconForm.vue"));
var _index = require("@/api/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  props: ['imgWidth', 'imgHeight', 'title', 'mulProps', 'iconList'],
  components: {
    iconForm: _iconForm.default
  },
  data: function data() {
    return {
      // iconList: [],
      areaList: []
    };
  },
  methods: {
    // 删除商品
    deleteItem: function deleteItem(index) {
      // Check if the index is valid
      if (index < 0 || index >= this.iconList.length) {
        throw new Error('Invalid index');
      }

      // Remove the element at the specified index using splice
      this.iconList.splice(index, 1);
      this.$set(this.iconList);
    },
    addItem: function addItem(index) {
      this.iconList.push({
        img: '',
        title: '',
        link: '',
        desc: '',
        phone: '',
        time: '',
        province: ''
      });
      this.$set(this.iconList);
    },
    // 升序
    upSortItem: function upSortItem(index) {
      if (index === 0) {
        return;
      }
      var item = this.iconList[index];
      this.$set(this.iconList, index, this.iconList[index - 1]);
      this.$set(this.iconList, index - 1, item);
    },
    // 降序
    downSortItem: function downSortItem(index) {
      if (index === this.iconList.length - 1) {
        return;
      }
      var item = this.iconList[index];
      this.$set(this.iconList, index, this.iconList[index + 1]);
      this.$set(this.iconList, index + 1, item);
    },
    // 处理级联选择器内容
    getProvince: function getProvince(index, e) {
      console.log('index e', index, e);
      var provinceId = e[1];
      // 将provinceId赋值给对应的商品对象
      this.iconList[index].province = provinceId;
      // 使用this.$set
      this.$set(this.iconList, index, this.iconList[index]);
    },
    formatTime: function formatTime(date) {
      return date.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    formatTimeRange: function () {
      var _formatTimeRange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(timeStrings) {
        var dates, startTime, endTime;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dates = timeStrings.map(function (timeString) {
                  return new Date(timeString);
                });
                startTime = this.formatTime(dates[0]);
                endTime = this.formatTime(dates[1]);
                return _context.abrupt("return", "".concat(startTime, "-").concat(endTime));
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function formatTimeRange(_x) {
        return _formatTimeRange.apply(this, arguments);
      }
      return formatTimeRange;
    }(),
    getCurrentTime: function () {
      var _getCurrentTime = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(item) {
        var target, timeRange;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('getCurrentTime', item);
                target = this.iconList[item.index];
                _context2.next = 4;
                return this.formatTimeRange(item.time);
              case 4:
                timeRange = _context2.sent;
                console.log('timeRange', timeRange);
                target.time = timeRange;
              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getCurrentTime(_x2) {
        return _getCurrentTime.apply(this, arguments);
      }
      return getCurrentTime;
    }(),
    init: function init() {
      return;
      for (var i = 0; i < 1; i++) {
        this.iconList.push({
          img: '',
          title: '',
          link: '',
          desc: '',
          phone: '',
          time: '',
          province: ''
        });
      }
    },
    getAreaList: function getAreaList() {
      var _this = this;
      (0, _index.getAreas)().then(function (res) {
        _this.areaList = res ? res[0].sub : [];
      });
    }
  },
  mounted: function mounted() {
    this.init();
    this.getAreaList();
    console.log('iconList', this.iconList);
  }
};
exports.default = _default;